import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Card, LanguageSwitcher, Logo } from '@core/ui';


/**
 * Centered card layout for authentication pages (login only for now — there is
 * no self-service signup; accounts are created in the Django admin).
 */
export function AuthLayout() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col bg-[var(--color-bg-subtle)]">
      {/* Anchored near the top, not vertically centered: an error banner or a
          field message then pushes the form DOWN instead of re-centering it,
          so the fields stay under the cursor across attempts. */}
      <main className="flex-1 flex items-start justify-center px-4 pb-8 pt-[max(10vh,env(safe-area-inset-top))] sm:pt-[14vh]">
        <div className="w-full max-w-md">
          {/* The brand appears once, as the wordmark. The product name is not
              retyped underneath it (design-system rule); it names the browser
              tab instead — see `document.title` in `src/i18n/index.ts`. */}
          <div className="flex justify-center mb-6">
            <Logo className="h-9 w-auto" />
          </div>
          <Card className="shadow-sm p-6 sm:p-8">
            <Outlet />
          </Card>
        </div>
      </main>
      {/* --color-text-secondary, not -muted: this sits on --color-bg-subtle, where
          muted is 4.33:1 and fails AA (see docs/features/ADR-0004-design-system.md). */}
      <footer className="flex flex-col items-center gap-y-3 px-4 py-6 text-center text-xs text-[var(--color-text-secondary)]">
        <LanguageSwitcher />
        <p>{t('footer.copyright', { year: new Date().getFullYear() })}</p>
      </footer>
    </div>
  );
}
